import {
  useState, useEffect, useRef, useMemo
} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { Range } from 'rc-slider'
import Button from '../Button/Button'
import styles from './select.module.scss'

export default function SelectRange(props) {
  const selectRef = useRef()
  const itemListRef = useRef()
  const {
    label,
    placeholder = 'Placeholder',
    stylingClass = '',
    disabled = false,
    onSelect = () => {},
    listMinWidth = 500,
    value,
    itemTextKey,
    min,
    max,
    step,
    initialValue,
    itemValueKey,
    errorText = '',
    ...otherProps
  } = props
  const initVal = useMemo(() => initialValue || [min, max], [initialValue, min, max])
  const [range, setRange] = useState(initVal)
  const [selectedValue, setSelectedValue] = useState()
  const [isActive, setIsActive] = useState(false)

  const handleClickOutside = (e) => {
    if (selectRef.current && !selectRef.current.contains(e.target)) {
      setIsActive(false)
    }
  }

  const applyRange = () => {
    setSelectedValue(range)
    onSelect(range)
    setIsActive(false)
  }

  const formatPrice = (val) => `฿${val.toString().replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`

  const checkListItemPosition = () => {
    const clientRect = itemListRef.current.getBoundingClientRect()
    const parentRect = selectRef.current.parentNode.getBoundingClientRect()
    if (selectRef.current.offsetLeft + clientRect.width > parentRect.left + parentRect.width) {
      itemListRef.current.style.left = 'unset'
      itemListRef.current.style.right = '0'
    } else if (itemListRef.current.style.removeProperty) {
      itemListRef.current.style.removeProperty('left')
      itemListRef.current.style.removeProperty('right')
    } else {
      itemListRef.current.style.removeAttribute('left')
      itemListRef.current.style.removeAttribute('right')
    }
  }

  useEffect(() => {
    if (isActive) {
      window.addEventListener('resize', checkListItemPosition)
      // window.dispatchEvent(new Event('resize'))
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      window.removeEventListener('resize', checkListItemPosition)
      document.removeEventListener('mousedown', handleClickOutside)
    }
    return () => {
      window.removeEventListener('resize', checkListItemPosition)
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isActive])

  useEffect(() => {
    setSelectedValue(value)
    setRange(value || initVal)
  }, [value, initVal])

  const handleRangeChange = (val) => {
    setRange(val)
  }
  return (
    <div
      ref={selectRef}
      className={`${styles.selectWrapper} ${stylingClass} ${errorText && styles.invalid}`}
      onClick={() => setIsActive(!isActive)}
      invalid={errorText && 'true'}
      disabled={disabled}
      {...otherProps}
    >
      {label && <span className={styles.label}>{label}</span>}
      <div className={`${styles.select} ${isActive && styles.active}`}>
        {
          selectedValue
            ? <span className={`${styles.text}`}>{`${formatPrice(selectedValue[0])} - ${formatPrice(selectedValue[1])}`}</span>
            : <span className={`${styles.text} ${styles.placeholder}`}>{placeholder}</span>
        }
        <span className={styles.icon}>
          <FontAwesomeIcon icon={faChevronDown} width={20} />
        </span>
        <ul
          ref={itemListRef}
          className={styles.itemList}
          style={{ minWidth: listMinWidth }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={styles.title}>
            {`${placeholder}: ${formatPrice(range[0])} - ${formatPrice(range[1])}`}
          </div>
          <div className={styles.wrapInput}>
            <Range
              min={min}
              max={max}
              step={step}
              onChange={handleRangeChange}
              value={range}
              className={styles.input}
            />
            <Button stylingClass={styles.apply} onClick={applyRange}>
              Apply
            </Button>
          </div>
        </ul>
      </div>
      {errorText && <span className={styles.error}>{errorText}</span>}
    </div>
  )
}
